import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // ← tambahkan ini
import ReactDOM from 'react-dom/client';
import '@fortawesome/fontawesome-free/css/all.min.css';

import Navigation from './landing_page/navigation';
import Header from './landing_page/header';
import Features from './landing_page/features';
import About from './landing_page/about';
import Services from './landing_page/services';
import Footer from './landing_page/contact';
import JsonData from "./landing_page/data/data.json";
import "./landing_page/styles/index.module.scss";

const LandingPage = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const navigate = useNavigate(); 

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
          navigate("/dashboard");
    }

    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Footer data={landingPageData.Contact} />
    </div>
  );
};

export default LandingPage;
